import { render, staticRenderFns } from "./template.pug?vue&type=template&id=0003b255&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./style.sass?vue&type=style&index=0&id=0003b255&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../.nvm/versions/node/v16.20.2/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0003b255",
  null
  
)

export default component.exports